import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  colors: {
    mainGreen: {
      50: "#e0f7ec",
      75: "#D6F4E6",
      100: "#b3ebd0",
      200: "#80deb3",
      300: "#4dd094",
      400: "#26c57e",
      500: "#32C882", // Base color
      600: "#2cbb7a",
      700: "#25ac6e",
      800: "#178355",
      900: "#0f6641",
    },
    mainGray: {
      50: "#F6F7F8",
      75: "#EDEDED",
      100: "#DBDBDB",
      200: "#B6B6B6",
      300: "#929292",
      400: "#6D6D6D",
      450: "#5A5A5A",
      500: "#494949",
      600: "#242424",
    },
    mainRed: {
      300: "#F39881",
      500: "#F06E50",
    },
    mainYellow: {
      500: "#FFB255",
    },
    mainBlue: {
      500: "#2BA6FF",
    },
    mainOceanBlue: {
      500: "#0F7887",
    },
    mainMidnightBlue: {
      500: "#1E3237",
    },
  },
  fonts: {
    heading: '"Spoqa Han Sans Neo",sans-serif',
    body: '"Spoqa Han Sans Neo", sans-serif',
  },
  fontSizes: {
    xs: "10px",
    sm: "12px",
    md: "14px", // 기본 폰트 크기를 14px로 설정
    lg: "16px",
    xl: "18px",
  },
});

export default theme;
